var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudtop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 973,
    height: 352,
    viewBox: "0 0 973 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_376_500",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 973,
    height: 352
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.25 97.234C314.93 79.7203 296.178 106.613 296.178 137.871C231.458 48.7823 153.574 125.368 170.028 231.65C148.089 231.65 134.926 245.718 137.12 289.481C120.057 296.236 109.181 301.29 104.211 320.74C54.1298 321.143 27.0442 322.617 0 352L973 345.748C957.643 314.488 933.51 317.615 856.723 314.488C846.844 296.57 838.988 290.909 819.426 291.044C811.162 267.848 802.693 268.616 786.517 273.851C768.966 242.592 751.415 233.214 718.506 267.599C714.118 251.97 706.44 242.592 691.082 255.095C674.628 173.821 628.556 148.813 563.835 198.828C563.835 150.376 530.927 114.427 496.921 144.123C496.592 122.967 493.69 114.845 476.079 117.553C501.309 -21.5517 344.444 -48.1225 342.25 97.234Z",
    fill: "#FAFAFF"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_376_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.595 212.323C317.533 200.487 300.332 218.662 300.332 239.787C240.961 179.578 169.515 231.337 184.61 303.166C164.484 303.166 152.409 312.674 154.421 342.251C138.769 346.815 128.792 350.231 124.233 363.377C78.2915 363.649 53.4449 364.645 28.6362 384.503L921.206 380.278C907.118 359.151 884.98 361.264 814.54 359.151C805.478 347.041 798.272 343.216 780.327 343.307C772.746 327.63 764.977 328.149 750.138 331.687C734.038 310.561 717.938 304.223 687.749 327.462C683.724 316.899 676.68 310.561 662.592 319.011C647.498 264.083 605.234 247.182 545.864 280.984C545.864 248.238 515.675 223.943 484.481 244.013C484.179 229.714 481.516 224.225 465.361 226.055C488.506 132.044 344.608 114.086 342.595 212.323Z",
    fill: "#EECACB",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.25 97.234C314.93 79.7203 296.178 106.613 296.178 137.871C231.458 48.7823 153.574 125.368 170.028 231.65C148.089 231.65 134.926 245.718 137.12 289.481C120.057 296.236 109.181 301.29 104.211 320.74C54.1298 321.143 27.0442 322.617 0 352L973 345.748C957.643 314.488 933.51 317.615 856.723 314.488C846.844 296.57 838.988 290.909 819.426 291.044C811.162 267.848 802.693 268.616 786.517 273.851C768.966 242.592 751.415 233.214 718.506 267.599C714.118 251.97 706.44 242.592 691.082 255.095C674.628 173.821 628.556 148.813 563.835 198.828C563.835 150.376 530.927 114.427 496.921 144.123C496.592 122.967 493.69 114.845 476.079 117.553C501.309 -21.5517 344.444 -48.1225 342.25 97.234Z",
    fill: "#FAFAFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudtop);
export default __webpack_public_path__ + "static/media/cloudtop.5ecc8b18710e0f6150a808da3d6e5159.svg";
export { ForwardRef as ReactComponent };